import { Loader, MultiSelect, type MultiSelectProps } from '@mantine/core';
import { IconChevronDown } from '@tabler/icons-react';
import { useGetCities } from '../../api';

export const CitiesMultiSelect = ({ ...props }: MultiSelectProps) => {
  const { data, isLoading } = useGetCities();

  return (
    <MultiSelect
      data={data?.map(city => ({
        label: city.name,
        value: city.id.toString(),
      }))}
      rightSection={
        isLoading ? (
          <Loader size='xs' />
        ) : (
          <IconChevronDown size={20} color='var(--mantine-color-primary-7)' />
        )
      }
      searchable
      {...props}
    />
  );
};
